import { Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import { Button, Header, Divider } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import { ReportFormValues } from '../../app/models/user';
import { useState } from 'react';
import MySelectInput from '../../app/common/form/MySelectInput';
import MyTextArea from '../../app/common/form/MyTextArea';
import MyCheckInput from '../../app/common/form/MyCheckInput';
import { reportUserValidationSchema } from '../../app/common/form/FormikFormValidations';
import { reasonOptions } from '../../app/common/options/reasonOptions';

export default observer(function ReportIssueForm() {
    const {userStore, modalStore} = useStore();
    const { user } = userStore;
    const [msgNum, setMsgNum] = useState(0);
    
    function handleFormSubmit(values: ReportFormValues) {
        let newValues: ReportFormValues = {
            ...values,
            email: user!.subscriberEmail,
            reason: values.reason,
            message: values.message
        };
        userStore.reportIssue(newValues).then(() => modalStore.closeModal());
    }

    return (
        <Formik
            initialValues={{
                email: '', message: '', reason: '', agree: false, error: null
            }}
            onSubmit={values => handleFormSubmit(values)}
            validationSchema={reportUserValidationSchema}
        >
            {({handleSubmit, isSubmitting, errors, isValid, dirty, values}) => (
                <Form className='ui form error' onSubmit={handleSubmit} autoComplete='off'>
                    <Header as='h2' icon textAlign='center'>
                        <Header.Content>Need help?</Header.Content>
                        <Header.Subheader>Tell us what you need help with or report an issue</Header.Subheader>
                    </Header>
                    
                    <label 
                        className={'label-visible input-label'}
                    >Reason</label>
                    <MySelectInput options={reasonOptions} placeholder='Select Reason' name='reason' />

                    <label 
                        className={values.message ? 'label-visible input-label' : 'input-label'}
                    >Message</label>
                    <MyTextArea rows={5} placeholder='Message' name='message' 
                        onChange={(val: string) => setMsgNum(+val.length)} 
                    />
                    <label>{msgNum} of 200 max characters</label>

                    <Divider clearing hidden />

                    <MyCheckInput name='agree' 
                        label={<label>I have read and agree to the <a href='https://wsdot.wa.gov/about/policies/web-privacy-notice/' target='_blank' rel="noreferrer">Privacy Policy</a></label>} 
                    />

                    <Button
                        disabled={isSubmitting} 
                        loading={isSubmitting} positive content='SUBMIT' type='submit' fluid />
                </Form>
            )}
        </Formik>
    )
})